import React from "react";

const BurgerIcon = ({ className }) => (
  <svg className={className} width="26px" height="19px" viewBox="0 0 26 19">
    <g
      id="Hero-Sections"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        transform="translate(-326.000000, -26.000000)"
        stroke="currentColor"
        strokeWidth="2"
      >
        <g transform="translate(327.000000, 27.000000)">
          <path d="M0,0.8 L24,0.8" />
          <path d="M0,8.8 L24,8.8" />
          <path d="M9.6,16.8 L24,16.8" />
        </g>
      </g>
    </g>
  </svg>
);

export default BurgerIcon;
